import styled from 'styled-components';

const WelcomeScreensNavigationContainer = styled.div`
  width: 100%;
`;

export default WelcomeScreensNavigationContainer;
